import {
  project1Laptop,
  project1Mobile,
  project2Laptop,
  project2Mobile,
  project3Laptop,
  project3Mobile,
  project4Laptop,
  project4Mobile,
  project5Laptop,
  project5Mobile,
} from "./projectImages";

export const projectData = [
  {
    id: 1,
    image: project1Laptop,
    transitionImage: project1Mobile,
    title: "REACT - MEMORY APP API",
    codeLink: "https://github.com/obomheire/memories-app-server",
    liveLink: "https://react-memories-app-server.herokuapp.com/",
  },
  {
    id: 2,
    image: project2Laptop,
    transitionImage: project2Mobile,
    title: "REACT - MEMORY APP CLIENT",
    codeLink: "https://github.com/obomheire/memories-app-frontend",
    liveLink: "https://react-memories-appl.netlify.app/",
  },
  {
    id: 3,
    image: project3Laptop,
    transitionImage: project3Mobile,
    title: "JAVASCRIPT - ECOMMERCE WEB SITE API",
    codeLink: "https://github.com/obomheire/ecommerce-web-site-server",
    liveLink: "https://ecommerce-web-site-server.herokuapp.com/",
  },
  {
    id: 4,
    image: project4Laptop,
    transitionImage: project4Mobile,
    title: "JAVASCRIPT - ECOMMERCE WEB SITE CLIENT",
    codeLink: "https://github.com/obomheire/ecommerce-web-site-frontend",
    liveLink: "https://ecommerce-web-site-frontend.netlify.app/",
  },
  {
    id: 5,
    image: project5Laptop,
    transitionImage: project5Mobile,
    title: "NODE.JS - RECIPE MANAGEMENT API",
    codeLink: "https://github.com/obomheire/recipe-management-api",
  },
  {
    id: 6,
    image: project3Laptop,
    transitionImage: project3Mobile,
    title: "NODE.JS - EAZYPICK SHOPPING CAT API",
    codeLink: "https://github.com/obomheire/eazyPick-Server",
  },
];
